const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInvoice(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 370.32 370.32",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#020202"
    },
    d: "M320.816,63.219L261.94,4.339C259.156,1.561,255.39,0,251.457,0H74.271 C58.219,0,45.16,13.06,45.16,29.112v312.095c0,16.053,13.059,29.113,29.111,29.113h221.777c16.052,0,29.111-13.06,29.111-29.113 V73.703C325.16,69.769,323.6,65.998,320.816,63.219z M293.547,337.907H76.773V32.414h154.088v43.577 c0,10.554,8.554,19.106,19.105,19.106h43.58V337.907z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#020202"
    },
    d: "M103.827,149.16c0,8.284,6.716,15,15,15h132.667c8.284,0,15-6.716,15-15s-6.716-15-15-15H118.827 C110.542,134.16,103.827,140.876,103.827,149.16z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#020202"
    },
    d: "M251.494,224.16H118.827c-8.284,0-15,6.716-15,15s6.716,15,15,15h132.667c8.284,0,15-6.716,15-15 S259.778,224.16,251.494,224.16z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoice);
export default __webpack_public_path__ + "static/media/invoice.5d0721a1a6d1af13e6a2d797c7ea7d10.svg";
export { ForwardRef as ReactComponent };